import React, { useState } from 'react';
import { API, authHeaders, fmtPhone } from '../utils/helpers';

// ── Send estimate (26 Oct) ───────────────────────────────────────────────────
//
// From the ticket window: the ticket as it is written up, sent to the customer
// to approve, through the quote flow (POST /api/quotes/estimate). The customer
// approves or says not now on their phone; the shop's Settings decide where
// the ticket goes on each answer. All or nothing: the customer approves the
// whole estimate (Manny, 26 Oct). Nothing is added to the ticket.

const money = (n) => `$${(Number(n) || 0).toFixed(2)}`;

export default function EstimateSend({ ticketId, detail, T, onClose, onSent }) {
  const c = (detail && detail.customer) || {};
  const lines = ((detail && detail.lineItems) || []).filter(l => !l.isTimerLine);
  const [channel, setChannel] = useState(c.phone ? 'sms' : 'email');
  const [phone, setPhone] = useState(c.phone || '');
  const [email, setEmail] = useState(c.email || '');
  const [note, setNote] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const send = async () => {
    setBusy(true); setError('');
    try {
      const r = await fetch(`${API}/api/quotes/estimate`, {
        method: 'POST', credentials: 'include', headers: authHeaders(true),
        body: JSON.stringify({ workorderId: ticketId, channel, phone, email, note }),
      });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(d.error || 'The estimate could not be sent.');
      onSent(d);
    } catch (e) { setError(e.message); }
    setBusy(false);
  };

  const field = { width: '100%', boxSizing: 'border-box', padding: '8px 10px', fontSize: 13, borderRadius: 6, background: T.input, border: `1px solid ${T.inputBorder}`, color: T.text, fontFamily: 'inherit' };
  const tab = (v, label) => (
    <button type="button" onClick={() => setChannel(v)} aria-pressed={channel === v}
      style={{ flex: 1, padding: '8px 0', fontSize: 13, fontWeight: 600, fontFamily: 'inherit', cursor: 'pointer', borderRadius: 6,
        border: `1px solid ${channel === v ? '#e67e22' : T.border}`, background: channel === v ? '#e67e22' : 'transparent', color: channel === v ? '#fff' : T.text }}>
      {label}
    </button>
  );
  return (
    <div role="dialog" aria-modal="true" aria-label="Send estimate" onClick={onClose}
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 3000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div onClick={e => e.stopPropagation()}
        style={{ width: '100%', maxWidth: 460, background: T.card, border: `1px solid ${T.cardBorder}`, borderRadius: 12, padding: 20, boxShadow: '0 20px 60px rgba(0,0,0,0.4)' }}>
        <div style={{ fontSize: 16, fontWeight: 700, color: T.text, marginBottom: 4 }}>Send estimate</div>
        <div style={{ fontSize: 12.5, color: T.textSub, lineHeight: 1.5, marginBottom: 14 }}>
          Ticket #{ticketId} as it is written up: {lines.length} line{lines.length !== 1 ? 's' : ''}, <strong style={{ color: T.text }}>{money(detail && detail.totalValue)}</strong> with tax.
          {' '}{c.name || 'The customer'} approves or says not now on their phone. Nothing is added to the ticket.
        </div>
        <div style={{ display: 'flex', gap: 8, marginBottom: 10 }}>{tab('sms', 'Text')}{tab('email', 'Email')}</div>
        {channel === 'sms' ? (
          <label style={{ display: 'block', fontSize: 12, color: T.textSub, marginBottom: 10 }}>Mobile
            <input value={phone} onChange={e => setPhone(e.target.value)} placeholder="(973) 555-0111" style={{ ...field, marginTop: 4 }} />
            {c.phone && phone === c.phone && <span style={{ fontSize: 11 }}>From Lightspeed: {fmtPhone(c.phone)}</span>}
          </label>
        ) : (
          <label style={{ display: 'block', fontSize: 12, color: T.textSub, marginBottom: 10 }}>Email
            <input value={email} onChange={e => setEmail(e.target.value)} placeholder="name@example.com" style={{ ...field, marginTop: 4 }} />
          </label>
        )}
        <label style={{ display: 'block', fontSize: 12, color: T.textSub, marginBottom: 12 }}>A note on the estimate (optional)
          <textarea value={note} onChange={e => setNote(e.target.value)} rows={3} placeholder="e.g. The rear shock needs a full rebuild; the front is fine for another season."
            style={{ ...field, marginTop: 4, resize: 'vertical' }} />
        </label>
        {!lines.length && <div style={{ fontSize: 12.5, color: '#e74c3c', marginBottom: 10 }}>There is nothing on this ticket yet. Add the parts and labor first.</div>}
        {error && <div style={{ fontSize: 12.5, color: '#e74c3c', marginBottom: 10 }}>{error}</div>}
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button onClick={onClose} disabled={busy}
            style={{ padding: '9px 16px', borderRadius: 8, border: `1px solid ${T.border}`, background: 'transparent', color: T.text, fontSize: 13, fontWeight: 600, fontFamily: 'inherit', cursor: 'pointer' }}>Cancel</button>
          <button onClick={send} disabled={busy || !lines.length}
            style={{ padding: '9px 18px', borderRadius: 8, border: 'none', background: '#e67e22', color: '#fff', fontSize: 13, fontWeight: 700, fontFamily: 'inherit', cursor: busy || !lines.length ? 'default' : 'pointer', opacity: busy || !lines.length ? 0.6 : 1 }}>
            {busy ? 'Sending…' : `Send estimate by ${channel === 'sms' ? 'text' : 'email'}`}
          </button>
        </div>
      </div>
    </div>
  );
}
